import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamRecordingTrimQuery } from "../graphql/queries";
import type {
  StreamRecordingTrimQueryType,
  StreamRecordingTrimQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamRecordingTrimQuery = (
  options?: QueryHookOptions<
    StreamRecordingTrimQueryType,
    StreamRecordingTrimQueryVariablesType
  >
) => {
  return useQuery<
    StreamRecordingTrimQueryType,
    StreamRecordingTrimQueryVariablesType
  >(StreamRecordingTrimQuery, options);
};
